// Datos de entrega del último pedido confirmado. Se guardan localmente para
// autocompletar el formulario del checkout la próxima vez que el cliente
// compre, sin obligarlo a escribir todo de nuevo.
export interface DeliveryInfo {
  name: string;
  phone: string;
  email: string;
  documentId: string;
  address: string;
  city: string;
  department: string;
}

const STORAGE_KEY = 'pcp_last_delivery';

// Lee los datos guardados. Devuelve null si no hay nada o están corruptos.
export function loadDeliveryInfo(): DeliveryInfo | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      name: String(parsed.name ?? ''),
      phone: String(parsed.phone ?? ''),
      email: String(parsed.email ?? ''),
      documentId: String(parsed.documentId ?? ''),
      address: String(parsed.address ?? ''),
      city: String(parsed.city ?? ''),
      department: String(parsed.department ?? ''),
    };
  } catch {
    return null;
  }
}

// Guarda los datos de entrega del pedido recién confirmado.
export function saveDeliveryInfo(info: DeliveryInfo): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(info));
  } catch {
    // almacenamiento no disponible, ignorar
  }
}